import defaultReducer from "./defaultReducer";

const initialState = { message: "", visible: false, onConfirm: () => {}}

export default defaultReducer('CONFIRM_MODAL', initialState);